import _defineProperty from '@babel/runtime/helpers/defineProperty';
import formatPrice from '@bwoty-web/price-formatter';
import cardTexts from '../Card.texts.js';
import { CardPaymentInfo as CardPaymentInfo$2, InnerWrapper, totalPriceContainer, reservedPaymentsContainer, reservedPayments, futurePayments, rowContainer } from './CardPaymentInfo.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import useGlobals from '../../../hooks/useGlobals.js';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';
import Typography from '../../Typography/Typography.js';
import Button from '../../Button/Button.js';
import ArrowLink from '../../Link/ArrowLink.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CardPaymentInfo = function CardPaymentInfo(_ref) {
  var _reservedPayments$pay, _reservedPayments$pay2;
  var _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
    _ref$buttonVariant = _ref.buttonVariant,
    buttonVariant = _ref$buttonVariant === void 0 ? 'primary' : _ref$buttonVariant,
    _ref$cardSettings = _ref.cardSettings,
    cardSettings = _ref$cardSettings === void 0 ? null : _ref$cardSettings,
    _ref$totalPrice = _ref.totalPrice,
    totalPrice = _ref$totalPrice === void 0 ? 0 : _ref$totalPrice,
    _ref$leftToPay = _ref.leftToPay,
    leftToPay = _ref$leftToPay === void 0 ? 0 : _ref$leftToPay,
    _ref$reservedPayments = _ref.reservedPayments,
    reservedPayments$1 = _ref$reservedPayments === void 0 ? null : _ref$reservedPayments,
    _ref$paymentDetails = _ref.paymentDetails,
    paymentDetails = _ref$paymentDetails === void 0 ? null : _ref$paymentDetails,
    _ref$onClickTraveldoc = _ref.onClickTraveldocuments,
    onClickTraveldocuments = _ref$onClickTraveldoc === void 0 ? null : _ref$onClickTraveldoc,
    _ref$onClickDiscountC = _ref.onClickDiscountCode,
    onClickDiscountCode = _ref$onClickDiscountC === void 0 ? null : _ref$onClickDiscountC,
    _ref$showButton = _ref.showButton,
    showButton = _ref$showButton === void 0 ? true : _ref$showButton;
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture,
    siteId = _useGlobals.siteId;
  var isGlobetrotter = useIsGlobetrotter();
  var hasFuturePayments = leftToPay > 0;
  return /*#__PURE__*/jsx(CardPaymentInfo$2, _objectSpread(_objectSpread({}, cardSettings), {}, {
    children: /*#__PURE__*/jsxs(InnerWrapper, _objectSpread(_objectSpread({}, cardSettings), {}, {
      children: [/*#__PURE__*/jsxs(totalPriceContainer, {
        children: [/*#__PURE__*/jsxs(Typography, {
          variant: "headline-s",
          children: [cardTexts[culture].totalPrice, ":"]
        }), /*#__PURE__*/jsx(Typography, {
          variant: "headline-s",
          children: formatPrice(totalPrice, siteId)
        })]
      }), reservedPayments$1 && (reservedPayments$1 === null || reservedPayments$1 === void 0 || (_reservedPayments$pay = reservedPayments$1.payments) === null || _reservedPayments$pay === void 0 ? void 0 : _reservedPayments$pay.length) > 0 && /*#__PURE__*/jsx(reservedPaymentsContainer, {
        children: reservedPayments$1 === null || reservedPayments$1 === void 0 || (_reservedPayments$pay2 = reservedPayments$1.payments) === null || _reservedPayments$pay2 === void 0 ? void 0 : _reservedPayments$pay2.map(function (item) {
          var _reservedPayments$res, _reservedPayments$res2;
          return /*#__PURE__*/jsxs(reservedPayments, {
            children: [/*#__PURE__*/jsx(Typography, {
              variant: "body-m",
              children: item.paymentType === 'ECARD' ? (_reservedPayments$res = reservedPayments$1.reservedPaymentsText) === null || _reservedPayments$res === void 0 ? void 0 : _reservedPayments$res.ECARD : (_reservedPayments$res2 = reservedPayments$1.reservedPaymentsText) === null || _reservedPayments$res2 === void 0 ? void 0 : _reservedPayments$res2.CARD
            }), /*#__PURE__*/jsx(Typography, {
              variant: "body-m",
              children: formatPrice(item.amount, siteId)
            })]
          }, item.paymentId);
        })
      }), hasFuturePayments && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsxs(Typography, {
          variant: "headline-s",
          children: [cardTexts[culture].futurePayments, ":"]
        }), paymentDetails.map(function (item) {
          return /*#__PURE__*/jsxs(futurePayments, {
            children: [/*#__PURE__*/jsx(Typography, {
              as: "h6",
              variant: "body-m",
              children: item.date
            }), /*#__PURE__*/jsx(Typography, {
              as: "h6",
              variant: "body-m",
              children: item.description
            }), /*#__PURE__*/jsx(Typography, {
              as: "h6",
              variant: "body-m",
              children: formatPrice(item.amount, siteId)
            })]
          }, item.description);
        })]
      }), /*#__PURE__*/jsxs(rowContainer, {
        children: [/*#__PURE__*/jsxs(Typography, {
          variant: "headline-s",
          children: [cardTexts[culture].leftToPay, ":"]
        }), /*#__PURE__*/jsx(Typography, {
          variant: "headline-s",
          children: formatPrice(leftToPay, siteId)
        })]
      }), showButton && /*#__PURE__*/jsx(Button, {
        size: isGlobetrotter ? 's' : 'm',
        variant: buttonVariant,
        children: buttonText || cardTexts[culture].payButton
      }), /*#__PURE__*/jsxs(rowContainer, {
        children: [onClickTraveldocuments && /*#__PURE__*/jsx(ArrowLink, {
          onClick: onClickTraveldocuments,
          children: cardTexts[culture].travelDocuments
        }), onClickDiscountCode && /*#__PURE__*/jsx(ArrowLink, {
          onClick: onClickDiscountCode,
          children: cardTexts[culture].addDiscountCode
        })]
      })]
    }))
  }));
};
var CardPaymentInfo$1 = CardPaymentInfo;

export { CardPaymentInfo$1 as default };
//# sourceMappingURL=CardPaymentInfo.js.map
